import React, { useState } from "react";
import { Box, Modal, Typography, IconButton, Button, InputAdornment, FormControl, InputLabel, OutlinedInput, Chip, TextField } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { mostrarError, mostrarExito } from "../../utils/Alertas";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { hideLoading, showLoading } from "../../../redux/actions/loadingActions";
import { RootState } from "../../../redux/store/store";
import AppModal from "../secondary/Modal";

interface ModalEditarRecetaProps {
    receta: {
        id: string;
        nombre: string;
        categoria: string;
        ingredientes: string[];
        apuntes?: string;
        imagenUrl: string;
    };
    onClose: () => void;
    onUpdate: () => void;
}

const ModalEditarReceta: React.FC<ModalEditarRecetaProps> = ({ receta, onClose, onUpdate }) => {
    const dispatch = useDispatch();
    const darkMode = useSelector((state: RootState) => state.theme.darkMode);
    const [ingredientes, setIngredientes] = useState<string[]>(receta.ingredientes || []);
    const [nuevoIngrediente, setNuevoIngrediente] = useState("");
    const [apuntes, setApuntes] = useState<string>(receta.apuntes || "");
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

    const handleAddIngrediente = () => {
        const val = nuevoIngrediente.trim();
        if (!val) return;
        const capitalized = val.charAt(0).toUpperCase() + val.slice(1);
        setIngredientes((prev) => [...prev, capitalized]);
        setNuevoIngrediente("");
    };

    const handleDeleteIngrediente = (index: number) => {
        const nuevaLista = [...ingredientes];
        nuevaLista.splice(index, 1);
        setIngredientes(nuevaLista);
    };

    const handleGuardar = async () => {
        try {
            await updateDoc(doc(db, "recetas", receta.id), {
                ingredientes,
                apuntes,
            });

            mostrarExito("Receta actualizada correctamente");
            onUpdate();
            onClose();
        } catch (error) {
            console.error(error);
            mostrarError("Error al actualizar la receta");
        }
    };

    // const handleEliminarReceta = async () => {
    //     try {
    //         await deleteDoc(doc(db, "recetas", receta.id));
    //         mostrarExito(`La receta "${receta.nombre}" ha sido eliminada.`);
    //         onUpdate();
    //         onClose();
    //     } catch (error) {
    //         console.error(error);
    //         mostrarError("Error al eliminar la receta.");
    //     }
    // };

    const handleEliminarReceta = async (event: React.MouseEvent<SVGSVGElement>) => {
        event.stopPropagation();
        setIsConfirmModalOpen(true);
    };

    const cancelDeleteReceta = () => {
        setIsConfirmModalOpen(false);
    };

    const confirmDeleteReceta = async () => {
        dispatch(showLoading());
        try {
            await deleteDoc(doc(db, "recetas", receta.id));
            mostrarExito(`La receta "${receta.nombre}" ha sido eliminada.`);
            onUpdate();
            onClose();
        } catch (error) {
            console.error("Error al eliminar la receta:", error);
            mostrarError("Error al eliminar la receta.");
        } finally {
            setIsConfirmModalOpen(false);
            dispatch(hideLoading());
        }

    };

    return (
        <Modal open={true} onClose={onClose}>
            <Box sx={{ backgroundColor: darkMode ? "#1F1F24" : "white", color: darkMode ? "#F2EFE9" : undefined, p: 3, m: "auto", mt: 6, maxWidth: { xs: 600, lg: 720 }, borderRadius: 2 }}>
                <div className="text-center">
                    <h2>Editar receta</h2>
                    <button
                        type="button"
                        className="btn btn-light btn-sm rounded-circle dt-modal-close"
                        onClick={onClose}
                        aria-label="Cerrar"
                        title="Cerrar"
                        style={{ marginTop: "54px" }}
                    >
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                </div>

                <TextField
                    fullWidth
                    multiline
                    label="Notas"
                    value={apuntes}
                    onChange={(e) => setApuntes(e.target.value)}
                    sx={{ my: 2 }}
                />

                <FormControl fullWidth sx={{ mt: 1 }}>
                <InputLabel>Ingredientes (pulsa la X para quitar)</InputLabel>
                    <OutlinedInput
                        label="Ingredientes (pulsa la X para quitar)"
                        readOnly
                        value=""
                        startAdornment={
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, py: 0.5 }}>
                            {ingredientes.map((ing, index) => (
                            <Chip
                                key={`${ing}-${index}`}
                                label={ing}
                                size={ingredientes.length >= 15 ? "small" : "medium"}
                                variant="outlined"
                                onDelete={() => handleDeleteIngrediente(index)}
                                sx={darkMode ? { color: "#F2EFE9", borderColor: "rgba(255, 255, 255, 0.10)" } : undefined}
                            />
                            ))}
                            {ingredientes.length === 0 && (
                                <Typography variant="body2" color="text.secondary" sx={{ py: 0.25 }}>
                                    Sin ingredientes
                                </Typography>
                            )}
                        </Box>
                        }
                        sx={{
                            alignItems: "flex-start",
                            minHeight: 56,
                            "& .MuiOutlinedInput-input": { display: "none" },
                            "& .MuiInputAdornment-root": { flexWrap: "wrap", maxWidth: "100%" },
                            paddingY: 1
                        }}
                    />
                </FormControl>

                {/* <Typography variant="subtitle1">Ingredientes</Typography>
                <Box>
                    {ingredientes.map((ing, index) => (
                        <Box
                            key={index}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                px: 1,
                                py: 0.5,
                                borderBottom: index !== ingredientes.length - 1 ? "1px solid #e0e0e0" : "none",
                            }}
                        >
                            <Typography
                                variant="body2"
                                sx={{
                                    flex: "1 1 auto",
                                    mr: 1,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    color: "text.primary",
                                }}
                            >
                                {ing}
                            </Typography>
                            <Box sx={{ width: 32, display: "flex", justifyContent: "flex-end" }}>
                                <IconButton
                                    onClick={() => handleDeleteIngrediente(index)}
                                    size="small"
                                    color="error"
                                    aria-label="Eliminar ingrediente"
                                    sx={{ p: 0.5 }}
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </Box>
                        </Box>
                    ))}
                </Box> */}

                <Box sx={{ my: 2, mb: 0 }}>
                    <TextField
                        label="Nuevo ingrediente"
                        value={nuevoIngrediente}
                        onChange={(e) => setNuevoIngrediente(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                handleAddIngrediente(); // ⇦ también al pulsar Enter
                            }
                        }}
                        fullWidth
                        slotProps={{
                            input: {
                                autoCapitalize: "sentences",
                            },
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        onClick={handleAddIngrediente}   // ⇦ y al pulsar el botón
                                        edge="end"
                                        aria-label="Añadir ingrediente"
                                        color="success"
                                        tabIndex={-1}
                                    >
                                        <AddIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>

                <Typography variant="caption" color="text.secondary" sx={{ pl: 0.5, mb: 1 }}>
                    Presiona "Intro" para añadir un ingrediente.
                </Typography>

                <Button variant="contained" fullWidth sx={{ mt: 2 }} onClick={handleGuardar} className="btn color-principal">
                    Guardar cambios
                </Button>

                <Button variant="outlined" color="error" fullWidth sx={{ mt: 2 }} onClick={(e: any) => handleEliminarReceta(e)}>
                    Eliminar receta
                </Button>

                {isConfirmModalOpen && (
                    <AppModal onClose={cancelDeleteReceta}>
                        <div className="modal-body">
                            <h2>Confirmar Eliminación</h2>
                            <p>¿Estás seguro de que deseas eliminar esta receta?</p>
                            <p>Esta acción no se puede deshacer.</p>
                            <div className="row">
                            <div className="col-6" style={{ paddingLeft: 0 }}>
                                    <button
                                        className="btn btn-secondary btn-block"
                                        onClick={cancelDeleteReceta}
                                    >
                                        Cancelar
                                    </button>
                                </div>
                                <div className="col-6" style={{ paddingRight: 0 }}>
                                <button
                                        className="btn btn-danger btn-block"
                                        onClick={confirmDeleteReceta}
                                    >
                                        Eliminar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </AppModal>
                )}
            </Box>
        </Modal>
    );
};

export default ModalEditarReceta;
